<template>
    <div v-if="priceRange" class="row align-items-center">
        <!-- From input -->
        <div class="col-auto p-0 pe-2">
            <div class="input-group input-group-sm">
                <input
                    id="input-from"
                    v-model.number="priceRange.distance_from"
                    type="number"
                    step="any"
                    class="form-control"
                    :disabled="true"
                />
                <span class="input-group-text">{{ distanceUnit }}</span>
            </div>
        </div>

        <!-- Dash -->
        <div class="col-auto px-2">
            <span>-</span>
        </div>

        <!-- To input -->
        <div class="col-auto p-0 pe-2">
            <div class="input-group input-group-sm">
                <input
                    id="input-to"
                    v-model.number="priceRange.distance_to"
                    type="number"
                    step="any"
                    class="form-control"
                    :disabled="true"
                />
                <span class="input-group-text">{{ distanceUnit }}</span>
            </div>
        </div>

        <!-- Price input -->
        <div class="col-auto p-0 px-2">
            <div class="input-group input-group-sm">
                <input
                    id="price"
                    v-model.number="priceValue"
                    type="number"
                    step="any"
                    class="form-control"
                />
                <span class="input-group-text">{{ currency }} / {{ weightUnit }}</span>
            </div>
        </div>

        <!-- Multiplied value -->
        <div class="col p-0 ps-2">
    <span v-if="multiplier !== 1">
      {{ (priceValue * multiplier).toFixed(3) }} {{ currency }} / {{ weightUnit }}
    </span>
        </div>
    </div>

</template>

<script>

export default {
    name: 'PriceRangeSelector',
    props: {
        price: {
            type: Object,
            default: null
        },
        multiplier: {
            type: Number,
            default: 1
        },
        weightUnit: {
            type: String,
            default: "-"
        },
        distanceUnit: {
            type: String,
            default: "-"
        }
    },
    data: function () {
        return {
            priceRange: null,
            priceValue: 0
        }
    },
    computed: {
        currency() {
            return import.meta.env.VITE_APP_CURRENCY || '€'
        }
    },
    watch: {
        priceValue() {
            if (this.priceValue && this.priceRange) {
                this.priceRange.price = (this.priceValue * 100).toFixed(1)
            }
        }
    },

    mounted: function () {
        this.priceRange = this.price
        this.priceValue = this.priceRange.price ? this.priceRange.price / 100.0 : 0
    }
}
</script>
